import { CSSProperties, PropsWithChildren } from 'react';

export type FlexRowProps = {
  style?: CSSProperties;
  className?: string;
}

export const FlexCenter = (props: PropsWithChildren<FlexRowProps>) => <div className={props.className} style={{...(props.style || {}), display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{props.children}</div>